import { graphql, Link, StaticQuery } from 'gatsby';
import React from 'react';
import { Link as LinkScroll } from "react-scroll";
import showdown from 'showdown';
import SocialNetworks from './SocialNetworks';
const converter = new showdown.Converter()

const links = [{
    name: "Inicio",
    to: "/",
    redirect: true
}, {
    name: "Blog",
    to: "/blog-page",
    redirect: true
}, {
    name: "Proyectos",
    to: "/projects-page",
    redirect: true
}, {
    name: "Contácto",
    to: "/contacts",
    redirect: true
}];

const Footer2 = ({
    data,
    location
}) => {
    const {
        desc
    } = data.markdownRemark.frontmatter.footer;

    return (
        <footer
            // style={{ backgroundColor: "black" }}
            className="position-relative container-fluid px-0">
            <img
                style={{
                    index: "-1",
                    height: "100%",
                    objectFit: "cover"
                }}
                src="/img/bdz-bg-footer.png"
                alt="footer"
                className="w-100 position-absolute" />
            <div className="container py-5">
                <div className="row">
                    <div className="col-md-4 px-5 mb-4 mb-md-0">
                        <Link className="navbar-brand" to="/">
                            <img
                                className="img-fluid"
                                src="/img/bdz-logo-white.png"
                                alt="placeholder"
                                style={{
                                    width: "120px",
                                    height: "80px"
                                }}
                            />
                        </Link>
                        <div
                            className="text-muted"
                            dangerouslySetInnerHTML={{ __html: converter.makeHtml(desc) }} />
                    </div>
                    <div className="col-md-3 px-5 mb-4 mb-md-0">
                        <h5 class="text-white font-weight-bold mb-4">Páginas</h5>
                        {
                            links.map((item, index) => (
                                item.redirect ? (
                                    <Link
                                        to={item.to}
                                        className={`nav-link text-white text-muted font-weight-bold p-0 pb-3`}>
                                        {item.name}
                                    </Link>
                                ) : (
                                        <>
                                            {
                                                location.pathname === "/" ? (
                                                    <LinkScroll
                                                        smooth={true}
                                                        duration={500}
                                                        to={item.to}
                                                        className={`c-pointer nav-link text-white text-muted font-weight-bold p-0 pb-3`}>
                                                        {item.name}
                                                    </LinkScroll>
                                                ) : (
                                                        <Link
                                                            to={`/#${item.to}`}
                                                            className={`nav-link text-white text-muted font-weight-bold p-0 pb-3`}>
                                                            {item.name}
                                                        </Link>
                                                    )
                                            }
                                        </>
                                    )
                            ))
                        }
                    </div>
                    <div className="col-md-5 px-5">
                        <SocialNetworks />
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
        query Footer2 {
            markdownRemark(frontmatter: { templateKey: { eq: "landing" } }) {
                frontmatter {
                    footer {
                        desc
                    }
                }
            }
        }
      `}
        render={(data, count) => <Footer2 data={data} count={count} {...props} />}
    />
)